// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { ITukWebpage, ITukWebpageApiResponse, ITukWebpageGetAttrs } from 'interfaces/webpage/tuk'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_tukList } from 'models/extensions/with-helper'

const TukWebpageStore = types
  .model('TukWebpage')
  .props({
    tukWebpage_isLoading: types.optional(types.boolean, false),
    tukWebpage_webpage: types.optional(types.array(withHelper_tukList()), []),
  })
  .actions(self => ({
    tukWebpage_SET_LOADING: (payload: boolean): void => {
      self.tukWebpage_isLoading = payload
    },
    tukWebpage_SET_TUK_WEBPAGE: (payload: ITukWebpage[]): void => {
      self.tukWebpage_webpage = cast(payload)
    },
    tukWebpage_CLEAR_TUK_WEBPAGE: (): void => {
      self.tukWebpage_webpage = cast([])
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    tukWebpage_fetchTukWebpage: flow(function* (payload: ITukWebpageGetAttrs) {
      self.tukWebpage_SET_LOADING(true)

      const response: ITukWebpageApiResponse = yield self.environment.tukWebpageApi.tukWebpage_getTuk(payload)
      if (response.ok) self.tukWebpage_SET_TUK_WEBPAGE(response.res.data)

      self.tukWebpage_SET_LOADING(false)
    }),
  }))

export const createTukWebpageStoreDefaultModel = () => types.optional(TukWebpageStore, {})
